import { Grid, Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationMinimumBilling from '@hook/parametrization/use-mininum-billing'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBar from '@component/Parameterization/MinimumBilling/SelectedTableBar'

const ParametrizationMinimumBolling: FC = () => {
  const { menuToggle } = useLayout()

  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    filename,
    params,
    filters,
    filtersList,
    fetching,
    query,
    tableInteraction,
    pagination,
    actions,
    getData,
    setFilename,
    setQuery,
    getCenters,
    handleUpdateParams
  } = useParametrizationMinimumBilling()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()

    data?.length === 0 && getData()
    getFilters({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Parametrização - Revisão">
      <Grid w="100vw" bg="white" h={height} templateColumns="100vw">
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={getData}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onSearchChange={setQuery}
            onTitleChange={setFilename}
            isDisabled={loading || fetching || data.length === 0}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os dados no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <Box>
              <SelectedTableBar />

              <Box paddingLeft={2}>
                <GridQuantity data={data} />
              </Box>

              <TableGrid
                id="purschase-table"
                headers={headers}
                query={query}
                data={data}
                loading={fetching}
                itsSortable={true}
                actions={tableInteraction}
                height={tableHeight}
                pagination={pagination}
              />
            </Box>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ParametrizationMinimumBolling
